import { render, staticRenderFns } from "./SiriWave.vue?vue&type=template&id=24b52918&scoped=true&"
import script from "./SiriWave.vue?vue&type=script&lang=js&"
export * from "./SiriWave.vue?vue&type=script&lang=js&"
import style0 from "./SiriWave.vue?vue&type=style&index=0&id=24b52918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b52918",
  null
  
)

component.options.__file = "SiriWave.vue"
export default component.exports